import React from 'react'

// קובייה כללית בדשבורד: כותרת + אייקון (או headSide במקומו)וכפתור תחתון אופציונלי
const StatCard = ({ title, icon, headSide, value, button, className = "", children }) => (
    <div className={`top-card ${className}`}>
        <div className='top-card-head'>
            <div className='top-card-title'>{title}</div>
            {headSide || (icon && <div className='top-card-icon'><i className={icon} /></div>)}
        </div>

        {value !== undefined && <div className='top-card-value'>{value}</div>}
        {children}

        {button &&
            <button className='pill-btn full' onClick={button.action} disabled={button.disabled}>
                {button.label}
                {button.icon && <i className={button.icon} />}
            </button>}
    </div>
)

export default StatCard
